const ROUTES_WITHOUT_SIDE_NAV = [
  '/login',
  '/signup',
  '/reset',
  '/reset-sent',
  '/resetverify',
  '/multifactor-authentication',
  '/recover-account',
]

export function hasSideNavigation(url: string, appMode: 'courts' | 'public' | 'portal' | 'default'): boolean {
  const urlWithoutQueryParams = url.split('?').at(0) ?? ''
  const isOnHomePage = urlWithoutQueryParams === '/'
  if (appMode === 'portal' && isOnHomePage) {
    return false
  }
  return !ROUTES_WITHOUT_SIDE_NAV.some(routeWithoutNav => urlWithoutQueryParams.endsWith(routeWithoutNav))
}
